import { Content } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `MediumWhiteCard`.
 */
export type MediumWhiteCardProps =
  SliceComponentProps<Content.MediumWhiteCardSlice>;

/**
 * Component for "MediumWhiteCard" Slices.
 */
const MediumWhiteCard = ({ slice }: MediumWhiteCardProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="max-w-screen-2xl mx-auto flex justify-center px-5 md:px-16 lg:-mt-16"
    >
      <div className="w-full xl:w-4/6 p-8 md:p-16 bg-white-gradient rounded-[20px]">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-7">
          <div className="w-full md:w-1/2 lg:w-1/3">
            <PrismicNextImage field={slice.primary.image} />
          </div>
          <div className="w-full lg:w-1/3 text-center lg:text-left">
            <PrismicRichText field={slice.primary.text} />
          </div>
          <div className="w-full lg:w-1/3 flex justify-center">
            <PrismicNextLink
              field={slice.primary.button_link}
              className="button-filled"
            >
              <span>{slice.primary.button_label}</span>
            </PrismicNextLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediumWhiteCard;
